(function ( $ ) {

    $(document).on('ready', function() {

        if ( typeof formWasSubmitted !== "undefined" && formWasSubmitted === true ) {
            $(".my-form__submit").hide(); // hiding trigger submit button after form submission, variable formWasSubmitted is being added via "gform_confirmation" php hook
        }

        $('.gform-submit-trigger').on('click', function () {
            var $this = $(this);

            $this.closest('.custom-block').find('.gform_button').trigger('click');
            // this spinner is being removed by JS as well, code for this is added via gform_register_init_scripts hook in custom-functions.php
            $this.next('.gform_ajax_spinner, .my-form__custom-spinner').show();
        });
        // adding classes for type-specific inputs to add custom css styles to appropriate gfields
        // Gravity-field with .radio-circles class has specific styles for its radio-items, so we do not add .gf-custom-dropdown class to it
        $('.ginput_container_radio').closest('.gfield').not('.radio-circles').addClass('radio-field gf-custom-dropdown');
        $('.ginput_container_checkbox').closest('.gfield').addClass('checkbox-field gf-custom-dropdown');
        $('.ginput_container_textarea').closest('.gfield').addClass('textarea-field');




        $('.my-form').each(function () {
            var $this = $(this);

            // adding click-handler for whole form-section that checks whether current opened dropdown should be closed
            $this.on('click', function (e) {
                if ( $(e.target).closest('.gf-custom-dropdown').length === 0 ) {
                    resetBottomPadding($this);
                    $('.ginput_container').each(function () { $(this).closest('.gf-custom-dropdown').removeClass('expanded'); });
                }
            });

            $this.find('[data-equalize-placeholder]').each(function () {
                $(this).closest('.gfield').addClass('gfield--text-input');
            });

            $this.addClass('visible');

        });




        var indentBAnimationSpeed = 400;
        var styleProp = '';

        // adding click-handler for opening custom gf-dropdowns (.gf-custom-dropdown css class is being added by JS upper in this script)
        $('.gf-custom-dropdown').on('click', function (e) {
            if ( e.target.classList.contains('gfield') ) {
                var $this = $(this);
                if ( $this.hasClass('expanded') ) {
                    $(this).removeClass('expanded').siblings('.gf-custom-dropdown').removeClass('expanded');
                    resetBottomPadding($this.closest('.my-form'));
                }
                else {
                    $(this).addClass('expanded').siblings('.gf-custom-dropdown').removeClass('expanded');
                    increaseBottomPadding($this.closest('.my-form'));
                }
            }
        });

        function increaseBottomPadding($form) {

            $form.removeAttr('data-prev-indent');

            resetBottomPadding($form, true);

            if ( $form.length > 0 ) {
                var formPos = $form.offset().top + $form.height(); // it is .my-form
                var $dropdownContainer = $form.find('.gf-custom-dropdown.expanded .ginput_container'); // current visible dropdown
                // getting dropdown and form offsets to detect if current expanded dropdown overflows it's .my-form
                var dropdownTopPos = $dropdownContainer.length > 0 ? $dropdownContainer.offset().top + $dropdownContainer.height() : 0;
                var diff = dropdownTopPos - formPos;

                styleProp = $form.hasClass('form-full-width') ? 'margin-bottom' : 'padding-bottom';

                if ( diff && (diff - parseInt($form.closest('.my-form').css('padding-bottom'))) > 0 ) {
                    // adding more padding to value on which $dropdownContainer overflows it's .gform_wrapper
                    if ( $form.hasClass('form-full-width') ) {
                        $form.attr('data-prev-indent', parseInt($form.css('padding-bottom'))).animate({ 'padding-bottom': diff }, indentBAnimationSpeed);
                    }
                    else {
                        $form.attr('data-prev-indent', parseInt($form.css('margin-bottom'))).animate({ 'margin-bottom': diff }, indentBAnimationSpeed);

                    }
                }
            }
        }

        function resetBottomPadding($form, noAnimation = false) {
            if ( $form.length > 0 ) {
                var indentToReset = $form.data('prev-indent');

                if ( typeof indentToReset !== "undefined" && indentToReset >= 0 ) {
                    if ( $form.hasClass('form-full-width') ) { // .form-full-width form do have padding-bottom, and .form-cols - does not
                        $form.animate({ 'padding-bottom': indentToReset }, noAnimation ? 0 : indentBAnimationSpeed);
                    } else {
                        $form.animate({ 'margin-bottom': indentToReset }, noAnimation ? 0 : indentBAnimationSpeed);
                    }

                } else {
                    $form.attr('style', '');
                }
            }
        }

    });
})( jQuery )